import { Link } from "react-router-dom";
import { Check, Pencil, X } from "lucide-react";
import { Button } from "@akuna/ui";
import type { MedicalRecordMobileConfig } from "./medical-record-mobile.types";

interface MobileMedicalRecordActionBarProps {
  config: MedicalRecordMobileConfig;
  secondaryLabel: string;
  primaryLabel?: string;
  editHref?: string;
  isSubmitting?: boolean;
  onSecondary: () => void;
  onPrimary?: () => void;
}

export function MobileMedicalRecordActionBar({
  config,
  secondaryLabel,
  primaryLabel,
  editHref,
  isSubmitting = false,
  onSecondary,
  onPrimary,
}: MobileMedicalRecordActionBarProps) {
  return (
    <footer
      data-testid="medical-record-mobile-actions"
      className="flex gap-2 border-t border-border/50 bg-background-app px-4 pt-3 pb-[calc(1rem+env(safe-area-inset-bottom))] md:hidden"
    >
      <Button variant="outline" className="h-11 shrink-0 rounded-full px-4" onClick={onSecondary}>
        <X className="h-4 w-4" />
        {secondaryLabel}
      </Button>
      {config.primaryAction === "edit" && editHref && primaryLabel ? (
        <Button asChild className="h-11 min-w-0 flex-1 rounded-full px-4">
          <Link to={editHref}><Pencil className="h-4 w-4" />{primaryLabel}</Link>
        </Button>
      ) : config.primaryAction && primaryLabel ? (
        <Button className="h-11 min-w-0 flex-1 rounded-full px-4" disabled={isSubmitting} onClick={onPrimary}>
          <Check className="h-4 w-4" />
          {primaryLabel}
        </Button>
      ) : null}
    </footer>
  );
}
